
        import 'QuoteFooter.a43f7e7.css-module'
        export default {"QuoteFooter":"QuoteFooter_QuoteFooter_a43f7e7","price":"price_QuoteFooter_a43f7e7","priceLink":"priceLink_QuoteFooter_a43f7e7","priceBreakdown":"priceBreakdown_QuoteFooter_a43f7e7","cancel":"cancel_QuoteFooter_a43f7e7","total":"total_QuoteFooter_a43f7e7"}
    